export default "__VITE_ASSET__17b7c929__"